import {
  Box,
  Center,
  Modal,
  ModalBody,
  ModalContent,
  ModalOverlay,
  useDisclosure,
} from '@chakra-ui/react';
import { useEffect, useState } from 'react';
import LiteYouTubeEmbed from 'react-lite-youtube-embed';

type ProductGallerySwiperVideoLightBoxProps = {
  videoUrl: string;
  visible: boolean;
  onClosed: () => void;
};

function ProductGallerySwiperVideoLightBox({
  videoUrl,
  visible,
  onClosed,
}: ProductGallerySwiperVideoLightBoxProps) {
  // use modal
  const { isOpen, onClose } = useDisclosure({
    isOpen: visible,
  });

  // youtube video id
  const [youtubeVideoId, setYoutubeVideoId] = useState<string>('');

  useEffect(() => {
    if (videoUrl) {
      // get youtube video id after last slash
      const videoId = videoUrl.split('/').pop();

      // lpg video id
      console.log('videoId', videoId);

      if (videoId) {
        setYoutubeVideoId(videoId);
      }
    }
  }, [videoUrl]);

  // handle modal close
  const handleModalClose = () => {
    onClose();
    onClosed();
  };

  return (
    <Modal isOpen={isOpen} onClose={handleModalClose} size="5xl">
      <ModalOverlay />
      <ModalContent margin="auto" maxWidth="900px" borderRadius="none">
        <ModalBody padding={4} bg="transparent" justifyContent="center">
          <Center className="youtubeContainer">
            {youtubeVideoId ? (
              <iframe
                width="900"
                height="506"
                src={`https://www.youtube-nocookie.com/embed/${youtubeVideoId}`}
                title="YouTube video player"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              ></iframe>
            ) : (
              <>
                <Box>
                  Video not found. Please check the video url and try again.
                </Box>
              </>
            )}
          </Center>
        </ModalBody>
      </ModalContent>
    </Modal>
  );
}

export default ProductGallerySwiperVideoLightBox;
